/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
let FRAMEWORK_CACHED_MAP;
function getAssetsCacheMap() {
  if (!FRAMEWORK_CACHED_MAP) {
    const win = window;
    win.LarCacheMap = win.LarCacheMap || {};
    FRAMEWORK_CACHED_MAP = win.LarCacheMap.map = win.LarCacheMap.map || new Map();
  }
  return FRAMEWORK_CACHED_MAP;
}
function addCachedAssets(assets) {
  const map = getAssetsCacheMap();
  Object.keys(assets).forEach(name => {
    map.set(name, assets[name]);
  });
}

export { addCachedAssets as a, getAssetsCacheMap as g };

//# sourceMappingURL=assets-helper-0799bcae.js.map